<template>
  <div class="Countdown">
    {{ timeRemaining }}
  </div>
</template>

<script lang="ts">
import WBComponent from "@/WBComponent";
import { Component } from "vue-property-decorator";

function twoDigitPrecision(n: number): string {
  const s = `${Math.floor(n)}`;
  if (n >= 10) {
    return s;
  } else {
    return `0${s}`;
  }
}

@Component
export default class Countdown extends WBComponent {
  intervalHandle = 0;
  timeRemaining = "";

  mounted() {
    this.intervalHandle = setInterval(
      this.updateTimer,
      1000
    ) as unknown as number;
    this.updateTimer();
  }

  updateTimer() {
    this.timeRemaining = this.getTimeRemaining();
  }

  beforeDestroy() {
    clearInterval(this.intervalHandle);
  }

  getTimeRemaining(): string {
    const tExpire = this.state.whiteboard.datetimeExpire;
    if (tExpire === null) return "";
    let seconds = tExpire - Date.now() / 1000;

    const secondsPerMinute = 60;
    const secondsPerHour = secondsPerMinute * 60;
    const secondsPerDay = secondsPerHour * 24;
    const days = Math.floor(seconds / secondsPerDay);
    seconds -= days * secondsPerDay;
    const hours = Math.floor(seconds / secondsPerHour);
    seconds -= hours * secondsPerHour;
    const minutes = Math.floor(seconds / secondsPerMinute);

    const timeString = `${twoDigitPrecision(hours)}:${twoDigitPrecision(
      minutes
    )}`;

    // TODO: localize
    if (days === 0) {
      return `${timeString} remaining`;
    } else if (days === 1) {
      return `1 day, ${timeString} remaining`;
    } else {
      return `${days} days, ${timeString} remaining`;
    }
  }
}
</script>

<style scoped lang="scss">
.Countdown {
  font-size: var(--font-size-tiny);
  color: var(--error);
}
</style>
